module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v("\n          " + _vm._s(_vm.promotions.length + (_vm.promotions.length === 1 ? ' promotion' : ' promotions')) + "\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new promotion")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-promotion-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.title),
      expression: "newPromotion.title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-promotion-title"
    },
    domProps: {
      "value": (_vm.newPromotion.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-promotion-desc"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "form-control form-control__editor",
    attrs: {
      "name": "text",
      "id": "textarea-promotion-desc",
      "editorToolbar": _vm.editorToolbar
    },
    model: {
      value: (_vm.newPromotion.text),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "text", $$v)
      },
      expression: "newPromotion.text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "promotion-button"
    }
  }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.button),
      expression: "newPromotion.button"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "promotion-button",
      "id": "promotion-button"
    },
    domProps: {
      "value": (_vm.newPromotion.button)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "button", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "promotion-link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.link),
      expression: "newPromotion.link"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "promotion-desc",
      "id": "promotion-link"
    },
    domProps: {
      "value": (_vm.newPromotion.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-roles"
    }
  }, [_vm._v("Access")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": false,
      "multiple": true,
      "options": _vm.getRolesForSelect,
      "data-lpignore": "true",
      "name": "roles",
      "id": "button-roles"
    },
    model: {
      value: (_vm.newPromotion.roles),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "roles", $$v)
      },
      expression: "newPromotion.roles"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-companies"
    }
  }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getCompaniesForSelect,
      "data-lpignore": "true",
      "name": "companies",
      "id": "button-companies"
    },
    model: {
      value: (_vm.newPromotion.companies),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "companies", $$v)
      },
      expression: "newPromotion.companies"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-industries"
    }
  }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": true,
      "multiple": true,
      "options": _vm.getIndustriesForSelect,
      "data-lpignore": "true",
      "name": "industries",
      "id": "button-industries"
    },
    model: {
      value: (_vm.newPromotion.industries),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "industries", $$v)
      },
      expression: "newPromotion.industries"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element target-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "button-targetUsers"
    }
  }, [_vm._v("Target users")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select",
    attrs: {
      "searchable": false,
      "multiple": false,
      "options": _vm.targetUsers,
      "data-lpignore": "true",
      "name": "targetUsers",
      "id": "button-targetUsers"
    },
    model: {
      value: (_vm.newPromotion.targetUsers),
      callback: function($$v) {
        _vm.$set(_vm.newPromotion, "targetUsers", $$v)
      },
      expression: "newPromotion.targetUsers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half",
    attrs: {
      "id": "date-selector"
    }
  }, [(_vm.newPromotion.targetUsers !== null) ? [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.targetDate),
      expression: "newPromotion.targetDate"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.newPromotion.targetDate)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "targetDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datepicker.shown),
      expression: "datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.targetDate,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event)
      }
    },
    model: {
      value: (_vm.datepicker.targetDate),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "targetDate", $$v)
      },
      expression: "datepicker.targetDate"
    }
  })], 1)])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.active),
      expression: "newPromotion.active"
    }],
    staticClass: "form-control form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": 'new-active-' + _vm.newPromotion.id,
      "name": "active"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPromotion.active) ? _vm._i(_vm.newPromotion.active, null) > -1 : (_vm.newPromotion.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPromotion.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newPromotion, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newPromotion, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newPromotion, "active", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": 'new-active-' + _vm.newPromotion.id
    }
  }, [_vm._v("Enabled")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFileUploaded),
      expression: "!isFileUploaded"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": 'promotionImage-0',
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0)
      }
    }
  })]), _vm._v(" "), (_vm.isFileUploaded) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: _vm.getImage(_vm.newPromotion.image)
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isFileUploaded) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0)
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "promotion-image-alt"
    }
  }, [_vm._v("Image alt")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPromotion.imageAlt),
      expression: "newPromotion.imageAlt"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "promotion-image-alt",
      "id": "promotion-image-alt"
    },
    domProps: {
      "value": (_vm.newPromotion.imageAlt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPromotion, "imageAlt", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createPromotion()
      }
    }
  }, [_vm._v("Create promotion")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Image")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Title ..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedPromotions), function(promotion, i) {
    return _c('tr', [(promotion.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("\n            " + _vm._s(promotion.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [(promotion.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      staticStyle: {
        "width": "50px",
        "height": "50px",
        "border": "none"
      },
      style: ({
        backgroundImage: _vm.getImage(promotion.image)
      })
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(promotion.title) + "\n          ")]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center"
    }, [_vm._v("\n            " + _vm._s(promotion.active ? 'Yes' : 'No') + "\n          ")]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.switchEditMode(promotion.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (promotion.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removePromotion(promotion.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (promotion.type === 'edit') ? _c('td', {
      staticClass: "edit-row chapter-edit",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', [_c('div', {
      staticClass: "form-group image-alt"
    }, [_c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!promotion.image),
        expression: "!promotion.image"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'promotionImage-' + promotion.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, promotion.id)
        }
      }
    })]), _vm._v(" "), (promotion.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: _vm.getImage(promotion.image)
      })
    }) : _vm._e(), _vm._v(" "), (promotion.image) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(promotion.id)
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-element featured-image-alt"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-image-alt"
      }
    }, [_vm._v("Image alt")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.imageAlt),
        expression: "promotion.imageAlt"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-image-alt",
        "placeholder": "Type in promotion image alt"
      },
      domProps: {
        "value": (promotion.imageAlt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "imageAlt", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-title"
      }
    }, [_vm._v("Promotion title")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.title),
        expression: "promotion.title"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-title",
        "placeholder": "Type in promotion title"
      },
      domProps: {
        "value": (promotion.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-text"
      }
    }, [_vm._v("Promotion text")]), _vm._v(" "), _c('vue-editor', {
      staticClass: "form-control form-control__editor",
      attrs: {
        "name": "text",
        "id": "edit-text",
        "editorToolbar": _vm.editorToolbar
      },
      model: {
        value: (promotion.text),
        callback: function($$v) {
          _vm.$set(promotion, "text", $$v)
        },
        expression: "promotion.text"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-text"
      }
    }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.button),
        expression: "promotion.button"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-button-text",
        "placeholder": "Type in promotion button text"
      },
      domProps: {
        "value": (promotion.button)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "button", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-link"
      }
    }, [_vm._v("Button link")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.link),
        expression: "promotion.link"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-button-link",
        "placeholder": "Type in promotion link"
      },
      domProps: {
        "value": (promotion.link)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "link", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-roles"
      }
    }, [_vm._v("Access")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": false,
        "multiple": true,
        "options": _vm.getRolesForSelect,
        "data-lpignore": "true",
        "name": "roles",
        "id": "edit-button-roles"
      },
      model: {
        value: (promotion.roles),
        callback: function($$v) {
          _vm.$set(promotion, "roles", $$v)
        },
        expression: "promotion.roles"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-companies"
      }
    }, [_vm._v("Company specific")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": true,
        "multiple": true,
        "options": _vm.getCompaniesForSelect,
        "data-lpignore": "true",
        "name": "companies",
        "id": "edit-button-companies"
      },
      model: {
        value: (promotion.companies),
        callback: function($$v) {
          _vm.$set(promotion, "companies", $$v)
        },
        expression: "promotion.companies"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-button-industries"
      }
    }, [_vm._v("Industry specific")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": true,
        "multiple": true,
        "options": _vm.getIndustriesForSelect,
        "data-lpignore": "true",
        "name": "industries",
        "id": "edit-button-industries"
      },
      model: {
        value: (promotion.industries),
        callback: function($$v) {
          _vm.$set(promotion, "industries", $$v)
        },
        expression: "promotion.industries"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "target-group--edit"
    }, [_c('div', {
      staticClass: "form-element target-group"
    }, [_c('div', {
      staticClass: "form-group form-group-half"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "button-targetUsers"
      }
    }, [_vm._v("Target users")]), _vm._v(" "), _c('v-select', {
      staticClass: "form-control form-control__select",
      attrs: {
        "searchable": false,
        "multiple": false,
        "options": _vm.targetUsers,
        "data-lpignore": "true",
        "name": "targetUsers",
        "id": "button-targetUsers"
      },
      model: {
        value: (promotion.targetUsers),
        callback: function($$v) {
          _vm.$set(promotion, "targetUsers", $$v)
        },
        expression: "promotion.targetUsers"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-group-half",
      attrs: {
        "id": "date-selector"
      }
    }, [(promotion.targetUsers !== null) ? [_c('div', {
      staticClass: "form-element"
    }, [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "new-company-subscription-end"
      }
    }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.targetDate),
        expression: "promotion.targetDate"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "data-lpignore": "true",
        "id": "new-company-subscription-end",
        "name": "Subscription ends"
      },
      domProps: {
        "value": (promotion.targetDate)
      },
      on: {
        "focus": function($event) {
          _vm.editDatepicker.shown = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(promotion, "targetDate", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editDatepicker.shown),
        expression: "editDatepicker.shown"
      }],
      staticClass: "datepicker"
    }, [_c('div', {
      staticClass: "datepicker-calendar-half"
    }, [_c('datepicker', {
      attrs: {
        "inline": true,
        "open-date": _vm.editDatepicker.targetDate,
        "format": 'dd/MM/yyyy'
      },
      on: {
        "selected": function($event) {
          return _vm.dateSelectedEdit($event, promotion)
        }
      },
      model: {
        value: (_vm.editDatepicker.targetDate),
        callback: function($$v) {
          _vm.$set(_vm.editDatepicker, "targetDate", $$v)
        },
        expression: "editDatepicker.targetDate"
      }
    })], 1)])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (promotion.active),
        expression: "promotion.active"
      }],
      staticClass: "form-control form-control__checkbox",
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true",
        "id": 'edit-active-' + promotion.id,
        "name": "active"
      },
      domProps: {
        "checked": Array.isArray(promotion.active) ? _vm._i(promotion.active, null) > -1 : (promotion.active)
      },
      on: {
        "change": function($event) {
          var $$a = promotion.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(promotion, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(promotion, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(promotion, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": 'edit-active-' + promotion.id
      }
    }, [_vm._v("Enabled")])])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.discardChanges(promotion.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editPromotion(promotion.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Dashboard promotions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c16d9e78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/DashboardPromotions.vue
// module id = 1052
// module chunks = 0